import { Subscription } from 'rxjs';
import { Component, Input, OnInit, OnDestroy, inject } from '@angular/core';
import { ExecutionState } from '../../../assets/data/enum/executionState';
import { OperationStateService } from '../../common/_services/operation-state.service';

@Component({
  selector: 'app-x-information-bar',
  templateUrl: './x-information-bar.component.html',
  styleUrls: ['./x-information-bar.component.css'],
  standalone: false,
})
export class XInformationBarComponent implements OnInit, OnDestroy {
  jwtHttpService = inject(OperationStateService);

  @Input() title = '';
  @Input() subtitle = '';
  @Input() sidebarOpen = true;
  localExecState: ExecutionState;
  enableMessage = true;
  private subscriptions: Subscription = new Subscription();
  executionState = ExecutionState.nostate;

  constructor() {}

  ngOnInit() {
    // Subscribe to enableMessage observable safely
    this.subscriptions.add(
      this.jwtHttpService.enabledMessageAlertAPI$.subscribe((check) => {
        // Defer update to next microtask to avoid ExpressionChangedAfterItHasBeenCheckedError
        Promise.resolve().then(() => {
          this.enableMessage = check;
        });
      })
    );

    // Creating subscriptions for status bar
    this.subscriptions.add(
      this.jwtHttpService.getStateOperation().subscribe((res) => {
        Promise.resolve().then(() => {
          this.executionState = res;

          if (res !== ExecutionState.nostate) {
            this.resetExecutionState();
          }
        });
      })
    );

    // Subscribe to title/subtitle observable safely
    this.subscriptions.add(
      this.jwtHttpService.getBarMessage().subscribe((res) => {
        Promise.resolve().then(() => {
          this.title = res.title;
          this.subtitle = res.subtitle;
        });
      })
    );
  }

  resetExecutionState = () => {
    setTimeout(() => {
      this.jwtHttpService.showOperationInProgress$.next(ExecutionState.nostate);
    }, 3000);
  };

  public get localExecutionState(): typeof ExecutionState {
    return ExecutionState;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
